import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import api from "../lib/api";
import Reveal from "../components/Reveal";
import { PillButton, Overline } from "../components/primitives";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);

  const categories = [...new Set(faqs.map((f) => f.category))];

  return (
    <div className="pt-16 md:pt-20">
      <section className="py-20 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <Reveal>
            <Overline>Questions & Answers</Overline>
            <h1 className="mt-4 font-display font-extrabold tracking-tighter text-4xl md:text-6xl">Frequently asked</h1>
            <p className="mt-4 text-lg text-foreground/70">Everything about flights, passports, fitness, payments, and more.</p>
          </Reveal>
        </div>
      </section>

      <section className="pb-28">
        <div className="max-w-3xl mx-auto px-6 md:px-10 space-y-10">
          {categories.map((cat) => (
            <div key={cat}>
              <div className="overline text-primary mb-2">{cat}</div>
              <Accordion type="single" collapsible>
                {faqs.filter((f) => f.category === cat).map((f) => (
                  <AccordionItem key={f.id} value={f.id}>
                    <AccordionTrigger className="text-left font-display font-semibold" data-testid={`faq-${f.id}`}>{f.q}</AccordionTrigger>
                    <AccordionContent className="text-foreground/70">{f.a}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
          <div className="pt-6"><Link to="/book"><PillButton>Book Your Retreat</PillButton></Link></div>
        </div>
      </section>
    </div>
  );
}
